import QrcodeView from './Qrcode.view';

const QrcodeContainer = ({ type }) => {
  let hash = window.location.hash;
  if (hash) hash = hash.replace('#', '');

  return <QrcodeView type={type} app={hash} />;
};

export default QrcodeContainer;
